module.exports = __webpack_public_path__ + "img/bd_Special_adImg.78c0ab5d.jpg";